import { useNavigate, useParams } from "react-router";
import { TopBarRoute } from "../../../components/templates";
import { useTask, useTaskActions } from "../useTasks";
import {
  ActionMenu,
  Card,
  H3,
  Stack,
  useActions
} from "@introist/react-foundation/v2";
import { IconPickerIcon } from "../../../components/organisms";
import { useState } from "react";
import { TaskForm } from "../TaskForm";
import { UpsertModal } from "../../../foundation";
import { TaskAssignments } from "../components/TaskAssignments";

export const TaskRoute = () => {
  const { onConfirmAction } = useActions();
  const navigate = useNavigate();
  const { id } = useParams();

  const { task } = useTask(id!);
  const { update, remove } = useTaskActions();

  const [editOpen, setEditOpen] = useState(false);

  const onDelete = onConfirmAction(
    () => remove(task!.id).then(() => navigate("/tasks", { replace: true })),
    {
      title: "Confirm deletion",
      description: "Are you sure you want to delete this task? This will also remove all assignments."
    }
  );

  return (
    <TopBarRoute
      narrow
      paths={[
        { key: "tasks", title: "Tasks", onClick: () => navigate("/tasks") },
        { key: "task", title: task?.title || "" }
      ]}
    >
      <Stack vertical>
        {task && (
          <Card style={{ padding: "var(--spacing-xLarge)" }}>
            <Stack>
              <Stack vertical gap="xLarge">
                <Stack>
                  <IconPickerIcon icon="check" fallbackIcon="check" />
                  <H3>{task.title}</H3>
                </Stack>
              </Stack>
              <Stack style={{ marginLeft: "auto" }}>
                <ActionMenu
                  options={[
                    {
                      key: "edit",
                      title: "Edit",
                      startAdornmentIcon: "pencil",
                      onClick: () => setEditOpen(true)
                    },
                    {
                      key: "delete",
                      title: "Delete",
                      startAdornmentIcon: "trash",
                      onClick: onDelete
                    }
                  ]}
                />
              </Stack>
            </Stack>
          </Card>
        )}
        {task && <TaskAssignments taskId={task.id} />}
      </Stack>
      <UpsertModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        entry={task}
        onCreate={() => {
          throw new Error("Not implemented");
        }}
        onUpdate={async entry => {
          await update({ id: task!.id, update: entry });
        }}
        Form={TaskForm}
        entryName="Task"
      />
    </TopBarRoute>
  );
};
